import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({
  rootNodeId: 'supplemental-premium-payments$root',
});

export const SupplementalPremiumPaymentMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
